var EasycomIframe = {};
EasycomIframe.init = function () {
  var headerSize = $('.navbar').innerHeight();
  var totalSectionSize = 0;
  var totalElementSize = 0;
  var browserHeight = window.innerHeight;
  var iframeHeight = 0;
  $('section.section:not(.section-easycom)').each(function (i, obj) {
    totalSectionSize = $(this).innerHeight();
  });
  totalElementSize = headerSize + 60;
  iframeHeight = browserHeight - totalElementSize;
  $('.easycom-wrapper').css('height', iframeHeight + 'px');
};
EasycomIframe.isBase64 = function (str) {
  try {
    return btoa(atob(str)) == str;
  } catch (err) {
    return false;
  }
};
EasycomIframe.renderIframe = function () {
  try {
    var easycomWrapper = $('.js-easycom-wrap');
    var query = window.location.search;
    if (easycomWrapper.length === 0) return;
    easycomWrapper.each(function () {
      var queryArr = query ? query.split('&') : [];
      var token = $(this).data('token');
      if (queryArr && queryArr[0]) {
        token = queryArr[0].split('?')[1];
      }
      if (EasycomIframe.isBase64(token) === false) {
        token = btoa(token);
      }
      if (typeof token !== 'undefined' && token) {
        var _window$Easycom, _window$Inretrn;
        ((_window$Easycom = window.Easycom) === null || _window$Easycom === void 0 ? void 0 : _window$Easycom.init({
          drToken: token
        })) || ((_window$Inretrn = window.Inretrn) === null || _window$Inretrn === void 0 ? void 0 : _window$Inretrn.init({
          drToken: token
        }));
      }
    });
  } catch (err) {
    return false;
  }
};
$(document).on('ready', function () {
  var returnModal = $('#js-returns-popup-modal');
  if ($('.js-easycom-wrap').length === 0 || returnModal.length === 0) return;
  returnModal.addClass('modal-is-active');
  var acceptTerm = returnModal.find('.js-acceptReturnTerms');
  if (acceptTerm.length > 0) {
    acceptTerm.on('click', function () {
      var button = $(this);
      button.addClass('is-loading');
      setTimeout(function () {
        returnModal.removeClass('modal-is-active');
        button.addClass('is-loading');
      }, 500);
    });
  }
});
$(window).on("load", function () {
  EasycomIframe.renderIframe();
});
EasycomIframe.init();


// WEBPACK FOOTER //
// ./scripts/components/easycom.js